import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigationArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		points: "16,3 3,29 16,24 29,29",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNavigationArrow;
